import { Answer, QuestionProps } from 'src/types/questionnaire.types';
import Button from '../../../../components/kit/button/Button';
import { useMemo } from 'react';

export const SingleSelectionQuestion = ({
  question,
  handleSelectAnswer,
  stepNumber,
  selectedOption = [],
}: QuestionProps) => {
  const onSelect = (answer: Answer) => {
    handleSelectAnswer({ ...question, choices: [answer] }, stepNumber);
  };
  const selected = useMemo(
    () => (selectedOption as Answer[])[0] ?? {},
    [selectedOption]
  );

  return (
    <>
      {(question.choices as Answer[]).map(({ id, title }) => (
        <Button
          type={selected?.id === id ? 'dark-grey' : 'light-grey'}
          key={id}
          width='full-width'
          style={{ width: '100%', marginLeft: 0 }}
          onClick={() => onSelect({ id, title })}
        >
          {title}
        </Button>
      ))}
    </>
  );
};
